module.exports = __webpack_public_path__ + "static/media/middle-middle-2.de3c9f44.png";